<template>
  <div>
    <AlertDetailDialog
      :dialog="dialog"
      @toggleD="toggleDialog"
      :alert="activeAlert"
    >
    </AlertDetailDialog>
    <Card>
      <Toolbar class="toolbar">
        <div class="mt-5">
          <v-toolbar-title class="subheading mt-3">{{
            $t("Alerts")
          }}</v-toolbar-title>
          <v-btn
            v-show="isAlertStatusNew && isMultiSelectActive"
            icon
            class="ml-0"
            @click="toggleSelectAll"
          >
            <v-icon v-show="!isSelectAll">mdi-checkbox-blank-outline</v-icon>
            <v-icon v-show="isSelectAll">mdi-checkbox-marked-outline</v-icon>
          </v-btn>

          <span v-show="isAlertStatusNew && isMultiSelectActive">Select All</span>
        </div>

        <v-spacer></v-spacer>

        <div class="mt-5">
          <div class="d-flex justify-end align-center">
            <TextInputField
              v-model="searchText"
              :placeholder="$t('Search')"
            ></TextInputField>
            <v-btn icon @click="download">
              <v-icon color="primaryText">get_app</v-icon>
            </v-btn>
            <v-btn icon @click="openCreateDialog = true">
              <v-icon>add</v-icon>
            </v-btn>

            <v-btn
              icon
              v-show="isAlertStatusNew"
              @click="toggleShowSelectAll"
              class="ma-0 pa-0"
            >
              <v-icon v-show="isMultiSelectActive"
                >mdi-checkbox-multiple-marked</v-icon
              >
              <v-icon v-show="!isMultiSelectActive">mdi-checkbox-multiple-blank-outline</v-icon>
            </v-btn>
          </div>

          <div class="d-flex align-center justify-end mt-2">
            <div class="text-right hidden-sm-and-down d-flex justify-end">
              {{ date.from }} - {{ date.to }}
            </div>
            <v-btn
              v-show="
                isAlertStatusNew && isMultiSelectActive && selectedIdList.length
              "
              color="success"
              class="align-center ml-3 mr-1"
              small
              @click="showActionDialog = true"
            >
              {{ $t("Resolve") }}
            </v-btn>
          </div>
        </div>
      </Toolbar>

      <div>
        <v-layout
          justify-center
          row
          wrap
          class="ma-0 pa-2 alert-container-height"
        >
          <v-flex v-show="isLoading" :class="{ 'd-flex': isLoading }" xs12>
            <v-spacer />
            <v-progress-circular
              v-show="isLoading"
              :size="50"
              color="primary"
              indeterminate
            />
            <v-spacer />
          </v-flex>

          <div v-if="!getTotalAlert && !isLoading">{{ $t("No Data") }}</div>
          <v-flex v-else xs12>
            <AlertCard
              v-for="item in alertData"
              :key="item.ref_id"
              :item="item"
              :activeFilter="activeFilter"
              :isCheckbox="isMultiSelectActive"
              :isSelected="checkedNewAlert[item.ref_id] || false"
              @update-selected="updateSelected"
              @click="
                dialog = true;
                activeAlert = item;
              "
            >
            </AlertCard>
          </v-flex>
        </v-layout>
      </div>
      <div class="pa-2 footer-bg">
        <v-layout align-center justify-space-between row wrap>
          <v-flex order-xs2 order-md1 shrink class="primaryText--text">
            <span class="alert-count caption"
              ><span class="alert-legend error"></span>
              {{ $t("New") }}
            </span>
            <span class="alert-count caption">
              <span class="alert-legend warning"></span>
              {{ $t("Acknowledge") }}
            </span>
            <span class="alert-count caption">
              <span class="alert-legend success"></span>
              {{ $t("Resolved") }}
            </span>
          </v-flex>
          <v-flex
            order-xs1
            order-md2
            shrink
            :ml-auto="$vuetify.breakpoint.smAndDown"
            :mr-auto="$vuetify.breakpoint.smAndDown"
          >
            <span class="primaryText--text"
              >{{ itemFrom }} - {{ itemTo }} of {{ getTotalAlert }}</span
            >
            <span>
              <v-btn
                avatar
                fab
                small
                :disabled="!hasPrevious"
                class="fab-btn-xs"
                @click="previous"
              >
                <v-icon>navigate_before</v-icon>
              </v-btn>
              <v-btn
                avatar
                fab
                small
                :disabled="!hasNext"
                class="fab-btn-xs"
                @click="next"
              >
                <v-icon>navigate_next</v-icon>
              </v-btn>
            </span>
          </v-flex>
        </v-layout>
      </div>
    </Card>
    <CreateAlert
      :open="openCreateDialog"
      @change:state="
        (value) => {
          openCreateDialog = value;
        }
      "
    />
    <AlertActionDialog
      :dialog="showActionDialog"
      @toggle="showActionDialog = false"
      :status="'resolved'"
      :ref_id="selectedIdList"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
const momentTz = require("moment-timezone");

import TextInputField from "@/components/utility/TextInputField";
import AlertDetailDialog from "@/components/Alert-v2/AlertDetailDialog";
import AlertCard from "@/components/Alert-v2/AlertCard";
import CreateAlert from "@/components/Alert-v2/CreateAlert";
import AlertActionDialog from "@/components/Alert-v2/AlertActionDialog";
import { EventBus } from "@/services/event-bus";
import { timezoneMixin } from "@/util/mixin/index";

export default {
  mixins: [timezoneMixin],
  props: {
    itemPerPage: {
      type: Number,
    },
    activeFilter: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  components: {
    TextInputField,
    AlertDetailDialog,
    AlertCard,
    CreateAlert,
    AlertActionDialog,
  },
  data() {
    return {
      dialog: false,
      openCreateDialog: false,
      activeAlert: {},
      searchText: "",
      page: 1,
      isAsc: false,
      showActionDialog: false,
      isMultiSelectActive: false,
      isSelectAll: false,
      checkedNewAlert: {},
    };
  },
  computed: {
    ...mapGetters(["getActivePlantTimezone"]),
    ...mapGetters("alert", ["getAlerts", "getTotalAlert", "isLoading"]),
    isAlertStatusNew() {
      return (
        this.activeFilter &&
        this.activeFilter.status &&
        this.activeFilter.status.value == "new"
      );
    },
    date() {
      return this.activeFilter && this.activeFilter.Date
        ? this.activeFilter.Date
        : {
            from: momentTz().tz(this.getActivePlantTimezone).format('YYYY-MM-DD'),
            to: momentTz().tz(this.getActivePlantTimezone).format('YYYY-MM-DD'),
          };
    },
    alertData() {
      let data = Object.values(this.getAlerts).map((el) => {
        return {
          ...el,
          created_time: el.created_time
            ? this.timezoneTime(el.created_time)
            : null,
          resolved_time: el.resolved_time
            ? this.timezoneTime(el.resolved_time)
            : null,
        };
      });
      if (this.searchText !== "") {
        data = data.filter((item) => {
          return (
            item.code.includes(this.searchText) ||
            (item.name && item.name.includes(this.searchText)) ||
            item.message.includes(this.searchText)
          );
        });
      }

      return data.sort((a, b) => {
        let sortBy =
          this.activeFilter && this.activeFilter.sortBy
            ? this.activeFilter.sortBy.value
            : "created_timestamp";

        if (a[sortBy] < b[sortBy]) {
          return this.isAsc ? -1 : 1;
        } else if (a[sortBy] > b[sortBy]) {
          return this.isAsc ? 1 : -1;
        } else {
          return 0;
        }
      });
    },
    itemFrom() {
      if (this.page === 1 && this.getTotalAlert > 0) {
        return 1;
      }
      return (this.page - 1) * this.itemPerPage;
    },
    itemTo() {
      if (this.page * this.itemPerPage > this.getTotalAlert) {
        return this.getTotalAlert;
      }
      return this.page * this.itemPerPage;
    },
    isNext() {
      return this.page * 10 < this.getTotalAlert;
    },
    selectedIdList() {
      return Object.keys(this.checkedNewAlert).filter(
        (id) => id != null && this.checkedNewAlert[id] == true
      );
    },
    hasNext() {
      return this.itemTo < this.getTotalAlert;
    },
    hasPrevious() {
      return this.itemFrom > 1;
    },
  },
  methods: {
    updateSelected({ id, selected }) {
      this.$set(this.checkedNewAlert, id, selected);
    },
    toggleShowSelectAll() {
      this.isMultiSelectActive = !this.isMultiSelectActive;
      this.isSelectAll = false;
      this.alertData.forEach((alert) => {
        this.$set(this.checkedNewAlert, alert.ref_id, false);
      });
    },
    toggleSelectAll() {
      this.isSelectAll = !this.isSelectAll;
      this.alertData.forEach((alert) => {
        if (this.isSelectAll) {
          this.$set(this.checkedNewAlert, alert.ref_id, true);
        } else {
          this.$set(this.checkedNewAlert, alert.ref_id, false);
        }
      });
    },
    download() {
      EventBus.$emit("alertDownload");
    },
    toggleDialog(value) {
      this.dialog = value;
      this.showActionDialog = false;
    },
    previous() {
      if (this.page > 1) this.page -= 1;
    },
    next() {
      if (this.isNext) this.page += 1;
    },
  },
  watch: {
    getAlerts() {
      this.isMultiSelectActive = false;
      this.isSelectAll = false;
      this.checkedNewAlert = {};
    },
    page: function () {
      EventBus.$emit("alertPageNum", this.page);
    },
  },
};
</script>

<style>
.cursor--pointer {
  cursor: pointer;
}
</style>
<style scoped>
.fab-btn-xs {
  height: 20px;
  width: 20px;
}

.truncate {
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.alert-label {
  border-left: 15px;
  border-right: 0px;
  border-top: 0px;
  border-bottom: 0px;
  /* border-color: green; */
  border-style: solid;
}

.alert-label-err {
  border-color: var(--v-error-base);
}

.alert-label-ack {
  border-color: var(--v-warning-base);
}

.alert-label-success {
  border-color: var(--v-success-base);
}

.alert-count {
  /* color: #fff; */
  align-items: center;
  margin: 0 10px;
  font-weight: bold;
}

.alert-legend {
  width: 12px;
  height: 12px;
  /* background-color: #DE625A; */
  border-radius: 50%;
  display: inline-block;
  margin-right: 6px;
}

.alert-container-height {
  height: 650px;
  max-height: 650px;
  overflow-y: scroll;
}

/* .theme--light .alert-text-color {
    color: #6a7a8c;
  }

  .theme--dark .alert-text-color {
    color: #b2b9bf;
  } */

.bg-alert-list {
  align-items: center;
  border-radius: 10px;
}

.theme--dark .bg-alert-list:hover {
  z-index: 200;
  /* background-color: #252C3E !important; */
  -webkit-transform: translateY(-4px);
  transform: translateY(-4px);
}

.theme--light .bg-alert-list:hover {
  z-index: 200;
  /* background-color: #cccccc !important; */
  -webkit-transform: translateY(-4px);
  transform: translateY(-4px);
}

/* .theme--dark .bg-alert-list {
    background-color: #1D2336;
  }

  .theme--light .bg-alert-list {
    background-color: #FBFBFB;
  } */

.alert-title {
  display: flex;
  align-items: center;
}

.alert-name {
  font-size: 16px;
  font-weight: bold;
}

/* .theme--light .alert-name {
    color: #6a7a8c;
  }

  .theme--dark .alert-name {
    color: #b2b9bf;
  } */

.alert-badge {
  border-radius: 6px;
  font-size: 12px;
  padding: 2px 6px;
  margin: 0 8px;
  text-transform: uppercase;
}
.flip-icon .v-icon {
  transform: scaleX(-1);
}

.toolbar {
  height: 100px;
}
.flip-icon .v-icon[data-v-bb41c1b0] {
  margin-left: 14px;
}
</style>
